
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Dialog, Typography, Card, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button } from "@mui/material";
import RegisterAccess from "../../utils/registerAccess";
import api from "../../services/api";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import ButtonLeft from "../../utils/buttonLeft";
import InputDocUpload from "../../utils/inputFileUpload/inputDocUpload";
import { useSelector } from "react-redux";

const ExpedienteForm = ({ open = false, setOpenForm }) => {
    const user = useSelector((state) => state.account.user);
    const [docExpediente, setDocExpediente] = useState({
        portador: '',
        requerente: '',
        tipoRemetente: '',
        nifBi: '',
        assunto: '',
        dataAnexo: '',
        tel: '',
        email: '',
        anexo: '',
        tipoDoc: '',
        descricao: '',
        remetidoPorTel: '',
        remetidoPorEmail: '',
        remetentoPorBi: '',
        numeroDocumento: '',
        anexoBi: '',
    })
    const [message, setMessage] = useState('')
    const [messageError, seterrorMessage] = useState('')
    const [tipoDocumento, setTipoDocumento] = useState([])
    // const [response, setResponse] = useState(false);
    const [openExpendiente, setOpenExpendiente] = useState(false)
    const [load, setLoad] = useState(false)
    const navigate = useNavigate()
    const { action } = useParams()

    const handleOpenExpediente = () => setOpenExpendiente(true);
    const handleCloseExpediente = () => { setOpenExpendiente(false); setMessage(''); seterrorMessage(''); setDocExpediente('') };

    useEffect(() => {
        setOpenExpendiente(open)
    }, [open])

    useEffect(() => {
        if (action === 'expediente') {
            handleOpenExpediente();
            setMessage('');
            setDocExpediente({
                portador: '',
                requerente: '',
                tipoRemetente: '',
                nifBi: '',
                assunto: '',
                tel: '',
                email: '',
                anexo: '',
                tipoDoc: '',
                descricao: '',
                remetidoPorTel: '',
                remetidoPorEmail: '',
                remetentoPorBi: '',
                anexoBi: '',
                numeroDocumento: '',
                dataAnexo: '',
            });
        }
    }, [action])

    useEffect(() => {
        api.get('/expediente-docs')
            .then((res) => {
                setTipoDocumento(res.data.expedienteDocss)
            })
            .catch((err) => seterrorMessage('Ocorreu algum problema ao carregar os tipos de Documentos'))
    }, [])

    function HandleChange(e) {
        e.target.files ?
            setDocExpediente({ ...docExpediente, [e.target.name]: e.target.files[0] })
            :
            setDocExpediente({ ...docExpediente, [e.target.name]: e.target.value })
    }

    async function HandleChangeFile(file, name) {
        setDocExpediente((prevCadastro) => ({ ...prevCadastro, [name]: file }))
    }

    async function createExpediente() {
        const formData = new FormData();
        formData.append('tipoRemetente', docExpediente.tipoRemetente);
        formData.append('nome', docExpediente.portador);
        formData.append('email', docExpediente.email ?? '');
        formData.append('numeroDocumento', docExpediente.numeroDocumento);
        formData.append('tel', docExpediente.tel);
        formData.append('descricao', docExpediente.descricao ?? '');
        formData.append('assunto', docExpediente.assunto);
        formData.append('tipoDocumentoId', docExpediente.tipoDoc);
        formData.append('remetidoPorNome', docExpediente.requerente);
        formData.append('remetidoPorTel', docExpediente.remetidoPorTel);
        formData.append('remetidoPorEmail', docExpediente.remetidoPorEmail);
        formData.append('remetidoPorBi', docExpediente.remetentoPorBi);
        formData.append('anexo', docExpediente.anexo);
        formData.append('dataAnexo', docExpediente.dataAnexo);
        formData.append('remetidoPorAnexoBi', docExpediente.anexoBi);
        formData.append('numeroDocumento', docExpediente.numeroDocumento);
        formData.append('userId', user?._id);

        setLoad(true)
        seterrorMessage('')
        setMessage('')

        await api.post('/expediente/create', formData)
            .then(res => {
                setLoad(false)
                setMessage(res.data)

                window.setTimeout(() => {
                    setMessage('');
                    setOpenForm && setOpenForm(false)
                }, 5000);

            }).catch(error => {
                seterrorMessage(error.response.data.message)
                setLoad(false)
            })
    }
    return (
        <div>
            <Dialog
                scroll='body'
                // onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openExpendiente}
                // maxWidth={'md'}
                fullWidth
            >
                <RegisterAccess page={'Registar Expediente'} />
                {message && <MessageSuccess message={message?.msg} />}
                {messageError && <MessageError message={messageError} />}

                <Typography align="center" >
                    <img src="/icones/iconExpediente-03.svg" width={80} style={{ margin: 10 }} />
                    <br />
                    REGISTO DE DOCUMENTOS
                </Typography>

                {!message &&
                    <Card style={{ padding: 20 }}>

                        <Typography align="left" style={{ marginTop: '20px', textTransform: 'uppercase' }}>
                            Dados do Remetente
                        </Typography>
                        <Grid xs={12} md item >
                            <TextField
                                margin="dense"
                                type="text"
                                label="Portador / Remetente"
                                fullWidth
                                size="small"
                                name="portador"
                                variant="outlined"
                                onChange={HandleChange}
                            />
                        </Grid>

                        <Grid xs={12} md item style={{
                            display: 'flex',
                            gap: '10px'
                        }}>
                            <FormControl style={{ width: '50%' }} margin="dense">
                                <InputLabel id="demo-simple-select-label">Tipo Remetente</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    type="text"
                                    label="Tipo Remetente"
                                    size="small"
                                    name="tipoRemetente"
                                    onChange={HandleChange}
                                >
                                    <MenuItem value='Instituição'>
                                        Instituição
                                    </MenuItem>
                                    <MenuItem value='Empresa'>
                                        Empresa
                                    </MenuItem>
                                    <MenuItem value='Singular'>
                                        Singular
                                    </MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl style={{ width: '50%' }} margin="dense">
                                <InputLabel id="demo-simple-select-label">Tipo de Documento</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    type="text"
                                    label="Tipo de Documento"
                                    size="small"
                                    name="tipoDoc"
                                    onChange={HandleChange}
                                >
                                    {tipoDocumento.map((documento) => (
                                        <MenuItem key={documento?._id} value={documento?._id}>
                                            {documento?.designacao}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                        </Grid>

                        <Grid xs={12} md item style={{
                            display: 'flex',
                            gap: '10px'
                        }}>
                            <TextField
                                margin="dense"
                                type="date"
                                label="Data do Documento"
                                size="small"
                                name="dataAnexo"
                                variant="outlined"
                                onChange={HandleChange}
                                InputLabelProps={{ shrink: true }}
                                style={{ width: '50%' }}
                            />
                            <TextField
                                margin="dense"
                                type="text"
                                label="Nº do Documento"
                                size="small"
                                name="numeroDocumento"
                                variant="outlined"
                                onChange={HandleChange}
                                style={{ width: '50%' }}
                            />

                        </Grid>

                        <Grid xs={12} md item style={{
                            display: 'flex',
                            gap: '10px'
                        }}>
                            <TextField
                                margin="dense"
                                type="number"
                                label="Tel."
                                size="small"
                                name="tel"
                                variant="outlined"
                                onChange={HandleChange}
                                style={{ width: '50%' }}
                            />
                            <TextField
                                margin="dense"
                                type="email"
                                label="Email"
                                fullWidth
                                size="small"
                                name="email"
                                variant="outlined"
                                onChange={HandleChange}
                                style={{ width: '50%' }}
                            />
                        </Grid>

                        <Grid xs={12} md item style={{
                            display: 'flex',
                            gap: '10px'
                        }}>
                            <TextField
                                margin="dense"
                                type="text"
                                label="Assunto"
                                fullWidth
                                size="small"
                                name="assunto"
                                variant="outlined"
                                onChange={HandleChange}
                            />
                        </Grid>
                        <Grid xs={12} md item >
                            <TextField
                                margin="dense"
                                type="text"
                                label="Observação"
                                fullWidth
                                size="small"
                                multiline
                                minRows={4}
                                name="descricao"
                                variant="outlined"
                                onChange={HandleChange}
                            />
                        </Grid>
                        <Grid xs={12} md item >

                            <InputDocUpload
                                imputLigth={true}
                                fullWidth={true}
                                onFileSelect={HandleChangeFile}
                                inputName={'anexo'}
                                inputDescription={'Anexo do Expediente'}
                                inputTitle={'Adicionar anexo'}
                                maxSizeInMB={10}
                            />

                        </Grid>
                        <ButtonLeft load={load} title={'Registar'} funcao={createExpediente} disabled={!docExpediente?.tipoDoc} children={undefined} >
                            <Button color="error" onClick={() => { handleCloseExpediente(); !open && navigate(-1) }}>Cancelar</Button>
                        </ButtonLeft>
                    </Card>
                }

                {message &&
                    <Card style={{ padding: 10, marginTop: 20 }}>
                        <Typography style={{ margin: 20 }} align="center">
                            <CheckCircleOutlineIcon fontSize="large" color="success" />
                            <br />
                            {message?.msg}
                            <br />
                            <b>Número de registo:</b> {message?.expediente?.numero}
                        </Typography>
                    </Card>
                }
            </Dialog>
        </div>
    )
}

export default ExpedienteForm
